import React from "react";
import "./GetMusicOnYandex.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnYandex = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music release",
    "Select Yandex Music distribution",
    "Music delivered to Yandex ecosystem",
    "Reach Russian & CIS listeners",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>Yandex Music Distribution | FT Tunes</title>

        <meta
          name="description"
          content="Distribute your music on Yandex Music worldwide with FT Tunes and reach millions of listeners across Russia and CIS countries."
        />

        <meta
          name="keywords"
          content="Yandex Music distribution, distribute music to Yandex, Yandex streaming platform"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="yandex-page">

        {/* HERO */}
        <section className="yandex-hero">
          <Container>

            <img
              src="/Images/Yandex_logo-1.png"
              alt="Yandex Music"
              className="yandex-logo"
            />

            <h1>Distribute Your Music on Yandex Music</h1>

            <p>
              Reach millions of music listeners across Russia and CIS markets
              through Yandex Music — one of the fastest growing streaming platforms.
            </p>

            <Button
              className="gradient-btn-yandex"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Distribution
            </Button>

          </Container>

          <div className="hero-glow-yandex"></div>
        </section>


        {/* SHOWCASE */}
        <section className="yandex-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Expand Into New Music Markets</h2>

                <p>
                  Yandex Music connects artists with millions of active users
                  through smart recommendations, playlists, and personalized
                  discovery features.
                </p>

                <Button
                  className="outline-btn-yandex"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-yandex.png"
                  alt="Yandex Music Distribution"
                  className="yandex-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="yandex-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-yandex">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="yandex-benefits">
          <Container>

            <h2 className="section-title">
              Why Distribute on Yandex Music
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-yandex">
                  <h5>Massive Audience</h5>
                  <p>Millions of active listeners.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-yandex">
                  <h5>Smart Discovery</h5>
                  <p>AI-powered recommendations.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-yandex">
                  <h5>Regional Growth</h5>
                  <p>Russia & CIS expansion.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-yandex">
                  <h5>Revenue Analytics</h5>
                  <p>Track performance easily.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="yandex-cta">
          <Container>

            <h2>Start Your Yandex Music Distribution Today</h2>

            <Button
              className="gradient-btn-yandex big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnYandex;